import React from 'react';
import { SonarText } from '@ui/text';
export const NotificationLinkDescription = ({ linkLabel, message, navigate, showLink, target }) => React.createElement(SonarText, null,
    message,
    React.createElement("br", null),
    showLink &&
        React.createElement(SonarText, { link: true, onClick: () => navigate(target) }, linkLabel));
